import { render, staticRenderFns } from "./CheckoutReview.vue?vue&type=template&id=7878ae1e"
import script from "./CheckoutReview.vue?vue&type=script&lang=js"
export * from "./CheckoutReview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports